import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomAdapter, CustomDateParserFormatter, SharedModule } from '@app/core/shared';
import { StartupModule } from '@app/core/startup/startup.module';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { RegistrationApprovalComponent } from './users/registration-approval/registration-approval.component';


@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        TranslateModule,
        ToastrModule.forRoot({ maxOpened: 1, preventDuplicates: true }),
        StartupModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        RegistrationApprovalComponent
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ],
})
export class AppExtensionModule { }
